import React, { useContext, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import http from "@shared/api/http";
import { BrandingContext } from "@shared/branding/BrandingContext";
import "@/assets/styles/Utils.css";
import { useTranslation } from "react-i18next";

function sendPatientRegistration(mail, password, props, applicationName, tenantId) {
  const url = "/:locale/v2/patient.json";
  var params = new FormData();
  params.append("patient[email]", mail.toLowerCase());
  params.append("patient[password]", password);
  params.append("patient[style]", applicationName);
  // Signed up from a tenant link: confirmation mail and page in its branding.
  if (tenantId != null) params.append("patient[tenant_id]", tenantId);
  http
    .post(url, params)
    .then(function (response) {
      props.setRegistrationSuccess(true);
    })
    .catch(function (error) {
      props.setRegistrationFailed(true);
    });
}

export function NewRegistration(props) {
  const [mail, setMail] = useState("");
  const [password, setPassword] = useState("");
  const [pwRepeat, setPwRepeat] = useState("");
  const { t, i18n } = useTranslation(); //eslint-disable-line no-unused-vars
  const { tenantId } = useContext(BrandingContext) || {};

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (password === pwRepeat) {
      sendPatientRegistration(mail, password, props, props.applicationName, tenantId);
      props.onHide();
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {t("user.registration")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>{t("password.mail")}</Form.Label>
            <Form.Control
              type="email"
              placeholder="user@patient.com"
              autoFocus
              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
              required
              onChange={(e) => setMail(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>{t("password.at-least-characters")}</Form.Label>
            <Form.Control
              type="password"
              pattern=".{8,20}"
              placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;"
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>{t("password.repeat")}</Form.Label>
            <Form.Control
              type="password"
              pattern=".{8,20}"
              placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;"
              onChange={(e) => setPwRepeat(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button className="bs-button-color" type="submit">
            {t("actions.send")}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
